import { createSlice } from "@reduxjs/toolkit";
import {
  getUnits,
  addNewUnit,
  updateUnit,
  deleteUnit,
  getUnitById,
  getUnitsByBlock,
} from "./thunk";
import {getContracts} from "../contracts/thunk";

export const initialState = {
  units: [],
  error: null,
  selectedUnit: null,
  isUnitSuccess: false,
  isUnitCreated: false,
  loading: false
};

const unitsSlice = createSlice({
  name: "UnitsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch units
    builder.addCase(getUnits.fulfilled, (state, action) => {
      state.units = action.payload;
      state.isUnitSuccess = true;
      state.error = null;
      state.loading = false;
    });

    builder.addCase(getUnits.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch units";
      state.isUnitSuccess = false;
      state.loading = false;
    });
    builder.addCase(getUnits.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    // Fetch a single unit by ID
    builder.addCase(getUnitById.fulfilled, (state, action) => {
      state.selectedUnit = action.payload; // Set the selected unit
      state.error = null;
    });

    builder.addCase(getUnitById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch unit by ID";
      state.selectedUnit = null; // Clear the selected unit on failure
    });

    // Add new unit
    builder.addCase(addNewUnit.fulfilled, (state, action) => {
      state.units.push(action.payload); // Add the new unit to the list
      state.isUnitCreated = true;
      state.error = null;
    });

    builder.addCase(addNewUnit.rejected, (state, action) => {
      state.error = action.payload || "Failed to add unit";
      state.isUnitCreated = false;
    });

    // Update unit
    builder.addCase(updateUnit.fulfilled, (state, action) => {
      state.units = state.units.map((unit) =>
        unit.id === action.payload.id ? { ...unit, ...action.payload } : unit
      );
      state.error = null;
    });


    builder.addCase(updateUnit.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update unit";
    });

    builder.addCase(getUnitsByBlock.fulfilled, (state, action) => {
      state.units = action.payload; // Update units list with block-specific data
      state.isUnitSuccess = true;
      state.error = null;
    });

    builder.addCase(getUnitsByBlock.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch units by block";
      state.isUnitSuccess = false;
    });

    // Delete unit
    builder.addCase(deleteUnit.fulfilled, (state, action) => {
      state.units = state.units.filter(
        (unit) => unit.id !== action.payload.unitId
      );
      state.error = null;
    });

    builder.addCase(deleteUnit.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete unit";
    });
  },
});

export default unitsSlice.reducer;
